// extracted by mini-css-extract-plugin
module.exports = {"button":"e419099df20a4a8f75c1bdbf3f0dd89e","text":"df7620a803efadbc532bcce478b9e3a8"};